import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';

import NotFoundImage from '../../mosaic/images/404-illustration.svg';
import NotFoundImageDark from '../../mosaic/images/404-illustration-dark.svg';
import ServiceLayout from "../../layout/ServiceLayout.jsx";
import ConfirmEmailNotification from "../../layout/ConfirmEmailNotification.jsx";
import {useTranslation} from "react-i18next";
import {useRequireLoginEffect} from "../../components/auth/useRequireLoginEffect.js";

function NotFound() {

    let {t} = useTranslation();

    useRequireLoginEffect();

    return (
        <ServiceLayout>
            <ConfirmEmailNotification/>

            <div className="flex h-[100dvh] overflow-hidden">
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="max-w-2xl m-auto mt-16">
                            <div className="text-center px-4">
                                <div className="inline-flex mb-8">
                                    <img className="dark:hidden" src={NotFoundImage} width="176" height="176"
                                         alt="404 illustration"/>
                                    <img className="hidden dark:block" src={NotFoundImageDark} width="176" height="176"
                                         alt="404 illustration dark"/>
                                </div>
                                <div className="mb-6">
                                    {t('error-404.this-page-does-not-exist')}
                                </div>
                                <Link to="/" className="btn bg-indigo-500 hover:bg-indigo-600 text-white">
                                    {t('continue-to-application')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </ServiceLayout>
    );
}

export default NotFound;